module.exports = __webpack_public_path__ + "static/media/Delete_report.3da34337.svg";